
<div class="background">
  <div class="back-btn" (click)="close()"></div>
  <div class="player-episodes focusable-container horizontal-focusable-container" data-blocked *ngIf="episodes">
      <app-cards-carousel
        #cardList
        [className]="'player__episodes'"
        [container]="episodes"
        [carouselType]="getCarouselType(episodes)"
        [showPlayIcon]="true"
        [navigateToPlayer]="true"
        [showProgress]="true"
        [isPlayerCarousel]="true"
        (clickAction)="close()"
        (cardWithFocus)="getNextPage($event)"
      ></app-cards-carousel>
  </div>
</div>
